<template>
    <div class="dashboard__ranking">
        <div class="card card--with-heading data-chart-ranking">
            <h4
                class="flex-direction-lg-column align-items-center align-items-lg-start"
            >
                <span>Ranking de empresas</span>
                <DashboardFilters
                    ref="filtersComponent"
                    @filter="getRankingDashboard"
                    :dashboardTab="dashboardTab"
                    :isAdmin="isAdmin"
                    :organizations="organizations"
                    filterFor="ranking"
                />
            </h4>
            <table class="n-table" v-if="dashboardRanking[0]">
                <thead>
                    <tr>
                        <th class="w-20">Nombre</th>
                        <th class="w-30">Establecimiento</th>
                        <th class="w-25">Cantidad</th>
                        <th>Precio sin IVA</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(entity, index) in dashboardRanking">
                        <tr
                            class="entity border-bottom"
                            :key="index + '-ranking'"
                        >
                            <td class="name w-20">{{ entity.company }}</td>
                            <td class="p-0 w-30"></td>
                            <td class="w-25">
                                <b class="offers"
                                    >{{ entity.count }} operaciones</b
                                >
                                <span class="quantity"
                                    >{{ entity.quantity }} animales</span
                                >
                            </td>
                            <td
                                data-label="Precio sin IVA"
                                class="ranking-table-label"
                            >
                                $/Kg
                                {{
                                    parseFloat(
                                        entity.averagePrice
                                    ).toLocaleString("de-DE", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </td>
                        </tr>

                        <tr
                            v-for="(
                                establishment, index
                            ) in entity.establishments"
                            :key="index + '-' + establishment.name"
                        >
                            <td class="p-0 w-20"></td>
                            <td class="w-30">{{ establishment.name }}</td>
                            <td class="w-25">
                                <b class="offers"
                                    >{{ establishment.count }} operaciones</b
                                >
                                <span class="quantity"
                                    >{{ establishment.quantity }} animales</span
                                >
                            </td>
                            <td
                                data-label="Precio sin IVA"
                                class="ranking-table-label"
                            >
                                $/Kg
                                {{
                                    parseFloat(
                                        establishment.price
                                    ).toLocaleString("de-DE", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <template v-else>
                <div v-if="!isLoading">
                    <div class="alert info">
                        <vs-icon icon="info" />
                        No existe suficiente información para mostrar el
                        ranking.
                    </div>
                </div>
                
            </template>
        </div>
    </div>
</template>

<script>
import DashboardFilters from "./DashboardFilters.vue";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const rankingDashboard = gql`
    query rankingDashboard(
        $currentUserToken: String!
        $scope: String!
        $scopedOrganizationId: Int
        $filters: DashboardFilterInput
    ) {
        rankingDashboard(
            currentUserToken: $currentUserToken
            scope: $scope
            scopedOrganizationId: $scopedOrganizationId
            filters: $filters
        ) {
            averagePrice
            company
            establishments {
                name
                count
                price
                quantity
            }
            quantity
            count
        }
    }
`;

export default {
    name: "ranking-dashboard",
    components: {
        DashboardFilters,
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        organizations: {
            type: Array,
            required: false,
            default: [],
        },
        scopedOrganizationId: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            isLoading: true,
            dashboardRanking: {},
        };
    },
    watch: {
        scopedOrganizationId() {
            this.getRankingDashboard();
        },
    },
    methods: {
        getRankingDashboard() {
            this.isLoading = true;
            var orgId =
                this.isAdmin && this.scopedOrganizationId
                    ? { scopedOrganizationId: this.scopedOrganizationId }
                    : {};
            var filter = this.$refs.filtersComponent;
            delete this.$refs.filtersComponent.filter.category; //Se elimina el objeto category para que no realice ninguna modificacion en el dash de entity
            if (!filter.invertedWeekFrom || !filter.invertedWeekTo) return;
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(rankingDashboard),
                        variables: Object.assign(
                            {
                                currentUserToken: localStorage.getItem(
                                    "USER_TOKEN"
                                ),
                                scope: this.dashboardTab,
                                filters: {
                                    weekFrom: filter.invertedWeekFrom,
                                    weekTo: filter.invertedWeekTo,
                                },
                            },
                            orgId
                        ),
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.dashboardRanking = res.data.data.rankingDashboard
                            ? res.data.data.rankingDashboard
                            : {};
                        this.isLoading = false;
                    }
                })
                .catch((err) => {});
        },
    },
};
</script>
